import React from 'react';
import { Link } from 'gatsby'
import { NavItem, NavInner } from './post-nav.style'
import { getSrc } from "gatsby-plugin-image"
import { FaAngleRight } from 'react-icons/fa'

const PostNav = ({ title, path, image, rel }) => {
    const imageSrc = getSrc(image);
    return (
        <NavItem rel={rel} className="post-nav">
            <Link to={`/${path}`}>
                <NavInner rel={rel} bgImage={imageSrc}>
                    <h6>{title}</h6>
                    <FaAngleRight />
                </NavInner>
            </Link>
        </NavItem>
    )
}

export default PostNav;
